import { render } from "./Holiday-Schedule.vue?vue&type=template&id=52fe4684&scoped=true"
import script from "./Holiday-Schedule.vue?vue&type=script&lang=js"
export * from "./Holiday-Schedule.vue?vue&type=script&lang=js"

import "./Holiday-Schedule.vue?vue&type=style&index=0&id=52fe4684&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2877492211/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fe4684"]])

export default __exports__